import React, { FC } from 'react';
import { Root } from './style';

export interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  transparency?: string;
  children?: React.ReactNode;
}

const Overlay: FC<OverlayProps> = ({ children, transparency, ...rest }) => {
  return (
    <Root transparency={transparency} {...rest}>
      {children}
    </Root>
  );
};

export default Overlay;
